<template>
    <div class="sa-follup">
        <h5 v-if="apt && !apt.insured" class="sa-card-tit">Video consultation (followUp)/Cash basic details</h5>
        <h5 v-else class="sa-card-tit">Video consultation (followUp)/Insurance details</h5>
    <div class="sa-mob-cont">
      <ul class="sa-card-list-gray">
        <li>
          <div class="sa-card-list-box">
            <div class="sa-doct-det sa-app-text">
              Appointment ID : <span class="sa-darkblue-text">{{apt.appnt_details.apnt_id}}</span>
            </div>
            <div class="sa-doct-det sa-app-text sa-text-right" :ref="presDiag1" @click="openToggle1(i)" :class="open1[i]?'active':''">
              Date : <span class="sa-darkblue-text sa-mr25">{{apt.appnt_details.date}}</span><span  :class="{ 'icon-plus sa-added-med': !open1[i], 'icon-minus sa-added-med': open1[i] }"></span>
            </div>
          </div>
            <div v-show="open1[i]">
               <hr />
            <h5 class="sa-card-tit">General details</h5>
          <div class="sa-row sa-mb20">
                <div class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
                  <div class="sa-form-group">
                  <label>Select Marital Status</label>
                  <div class="sa-card">{{apt.general_details.marital_status}}</div>
                  </div>
                </div>
                <div v-if="apt && apt.general_details && apt.general_details.gender == 'Female'" class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
                  <div class="sa-form-group">
                  <label>Select Pregnancy status</label>
                  <div class="sa-card">{{apt.general_details.pregnency_status}}</div>
                  </div>
                </div>
          </div>
                <h5 class="sa-card-tit">Diagnosis details</h5>
          <div class="sa-card">
                <label class="sa-diagno-label">
                  Subjective
                </label>
              {{apt.diagnosis_details.subjective}}
            </div>
            <div class="sa-card">
              <label class="sa-diagno-label">
                Objective
              </label>
              {{apt.diagnosis_details.objective}}
            </div>
            <div v-if="typeof apt.diagnosis_details.assessment == 'string'" class="sa-card">
              <label class="sa-diagno-label">
                Assessment
              </label>
              {{diagnosis.diagnosis_details.assessment}}
            </div>
            <div v-else class="sa-card">
                <label class="sa-diagno-label">
                Assessment
              </label>
                <div class="sa-row sa-med-tab-cnt">
                
                    <div  v-if="apt && apt.diagnosis_details && apt.diagnosis_details.assessment && apt.diagnosis_details.assessment.secondary" class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4  ">
              
              <p>Primary diagonosis</p>
              <p v-if="apt.diagnosis_details.assessment.primary.length == 0">Not Submitted</p>
              <p v-for="(item, index) in apt.diagnosis_details.assessment.primary" :key="index" class="sa-black-text">
                {{item.icd10_code}} ({{item.desc}})</p>
            </div>
            <div v-if="apt && apt.diagnosis_details && apt.diagnosis_details.assessment && apt.diagnosis_details.assessment.secondary " class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4  ">
              <p>Secondary diagonosis</p>
              <p v-if="apt.diagnosis_details.assessment.secondary.length == 0">Not Submitted</p>
            <p v-else v-for="(item, index) in apt.diagnosis_details.assessment.secondary" :key="index" class="sa-black-text">
                {{item.icd10_code}} ({{item.desc}})</p>
            </div>
            <div v-if="apt && apt.diagnosis_details && apt.diagnosis_details.assessment && apt.diagnosis_details.assessment.secondary" class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4  ">
              <p>Additional diagonosis</p>
              <p v-if="apt.diagnosis_details.assessment.additional.length == 0">Not Submitted</p>
              <p v-else v-for="(item, index) in apt.diagnosis_details.assessment.additional" :key="index" class="sa-black-text">
                {{item.icd10_code}} ({{item.desc}})</p>
              
            </div>
                </div>
            </div>
            <div class="sa-card sa-mb20">
              <label class="sa-diagno-label">
                Plan
              </label>
              {{apt.diagnosis_details.plan}}
            </div>
              <div v-if="apt && apt.followUp_slot == {}" class="sa-follow"></div>
            <div v-else  class="sa-follow">
                <h5  v-if="apt && apt.followUp_slot && apt.followUp_slot.date" class="sa-card-tit sa-mt20">Select follow up date and slot (Optional)</h5>
                <div v-if="apt && apt.followUp_slot && apt.followUp_slot.date" class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
                    <a class="sa-card sa-card-noshadow sa-card-border  sa-d-block sa-follow-icon">
                        <i class="icon-picker"></i>
                        {{apt.followUp_slot.date}}, {{apt.followUp_slot.strt_tym}} to {{apt.followUp_slot.end_tym}}
                    </a>
                </div>
            </div>
              <h5 v-if="apt && apt.prescription_details && apt.prescription_details.pres && apt.prescription_details.pres.length > 0" class="sa-card-tit sa-mt20">Prescription</h5>
              <div v-if="apt && apt.prescription_details && apt.prescription_details.pres && apt.prescription_details.pres.length > 0" class="sa-row">
                <div  v-for="(item, i) in apt.prescription_details.pres" :key="i" class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg3">
                  <div class="sa-card ">
                  <div class="sa-word-break" :ref="presDiag" @click="openToggle(i)" :class="open[i]?'active':''">
                    {{item[0].value}}
                      <span  :class="{ 'icon-plus sa-added-med': !open[i], 'icon-minus sa-added-med': open[i] }"></span>
                  </div>
                  <transition>
                      <div class="sa-pre-acc-cnt" v-show="open[i]">
                        <div class="sa-row sa-med-tab-cnt">
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 sa-med-tab-cnt ">
                            <label>{{item[1].name}}</label>
                            <span>{{item[1].value}}</span>
                          </div>
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[2].name}}</label>
                            <span>{{item[2].value}}</span>
                          </div>
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[3].name}}</label>
                            <span>{{item[3].value}}</span>
                          </div>
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[4].name}}</label>
                            <span>{{item[4].value}}</span>
                          </div>
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[5].name}}</label>
                            <span>{{item[5].value}}</span>
                          </div>
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[6].name}}</label>
                            <span>{{item[6].value}}</span>
                          </div>
                          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[7].name}}</label>
                            <span>{{item[7].value}}</span>
                          </div>
                          <div class="sa-col12 ">
                            <label>{{item[8].name}}</label>
                            <span>{{item[8].value}}</span>
                          </div>
                          <div class="sa-col12">
                            <label>{{item[9].name}}</label>
                            <span>{{item[9].value}}</span>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
              <!-- <button class="pdf-btn sa-primary-text "></button> -->
                </div>
              <div v-if="apt && apt.prescription_details" class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
                  <a target="_blank" :href="apt.prescription_details.pres_url" class="sa-card sa-card-noshadow sa-card-border sa-text-center sa-d-block">
                    <i class="icon-pdf sa-pdf"></i> Prescription
                  </a>
                </div>
            </div>
              <h5 v-if="apt && apt.treatment_referal && (apt.treatment_referal.doctor_referred ||
            apt.treatment_referal.test_packages_referred || apt.treatment_referal.nurse_referred || apt.treatment_referal.treatment_referred )"  class="sa-card-tit ">Treatment Referral</h5>
            <ul class="sa-refer-list sa-treat-ref-list">
              <li v-if="apt && apt.treatment_referal && apt.treatment_referal.doctor_referred" class="sa-sprite sa-doc-icon"><strong>Doctor</strong>
              <small>Referred Department - {{apt.treatment_referal.doctor.dept_name}}</small></li>
              <li v-if="apt && apt.treatment_referal && apt.treatment_referal.doctor_referred && apt.treatment_referal.doctor.name" class="sa-sprite sa-doc-icon">
                <strong>Doctor</strong><small>Referred Doctor - {{apt.treatment_referal.doctor.title}} {{apt.treatment_referal.doctor.name}}</small></li>
          
              <li v-if="apt && apt.treatment_referal && apt.treatment_referal.test_packages_referred && apt.treatment_referal.test_packages && apt.treatment_referal.test_packages.tests &&
              apt.treatment_referal.test_packages.package && (apt.treatment_referal.test_packages.tests.name.length > 0 || apt.treatment_referal.test_packages.package.name.length > 0)"
                  class="sa-sprite sa-test-pack">
                <strong>Select Test and Package</strong>
                <small v-for="(item, i) in apt.treatment_referal.test_packages.tests.name" :key="i">{{item.name}}</small>
                <span><small v-for="pack in apt.treatment_referal.test_packages.package.name" :key="pack.id">{{pack.name}}</small></span>
                </li> 
                
              <!-- <li class="sa-sprite sa-radiology"><strong>Select Radiology</strong><small>3 Radiology Selected</small></li> -->
              <li v-if="apt && apt.treatment_referal && apt.treatment_referal.nurse 
              && apt.treatment_referal.nurse.name && apt.treatment_referal.nurse.name.length > 0" class="sa-sprite sa-nurse">
              <strong>Nurse</strong>
              <small v-for="(item, i) in apt.treatment_referal.nurse.name" :key="i">Referred Task - {{item.name}}</small></li>

              <li v-if="apt && apt.treatment_referal && apt.treatment_referal.treatment_referred 
              && apt.treatment_referal.treatment.name && apt.treatment_referal.treatment.name.length > 0" class="sa-sprite sa-nurse"><strong>Physiotherapist</strong>
              <small v-for="(item, i) in apt.treatment_referal.treatment.name" :key="i">{{item.name}}</small></li>
            </ul>
           <h5 v-if="apt && apt.sick_url" class="sa-card-tit">Sick Leave</h5>
            <div class="sa-row">
              <div v-if="apt && apt.sick_url" class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg3">
                <a target="_blank" :href="apt.sick_url" class="sa-card sa-card-noshadow sa-card-border sa-text-center sa-d-block">
                  <i class="icon-pdf sa-pdf"></i> Sick leave Report
                </a>
              </div>
            </div>
            </div>
        </li>
      </ul>
    </div>
    </div>
</template>
<script>
export default {
  props: ["apt"],
    data(){
        return{
                  i : null,
                  open1: {},
                  presDiag1: 0,
                  presDiag: 0,
      open: {},
        }
    },
    methods: {
        openToggle(i) {
        let _self = this
        let flag = !_self.open[i]
        _self.$set(_self.open, i, flag)
        _self.presDiag += 1
      },
        openToggle1(i) {
        let _self = this
        let flag = !_self.open1[i]
        _self.$set(_self.open1, i, flag)
        _self.presDiag1 += 1
      }
    }
}
</script>